// DO NOT EDIT -- generated from fs/services/emissary/model.proto

import * as protobuf from '../../../google/protobuf';

export enum FieldType {
  UNSPECIFIED = 0,
  BOOL = 1,
  ENUM = 2,
  SET_ENUM = 3,
  TEXT = 4,
  TEXT_READONLY = 5,
  AUTOCOMPLETE = 6,
  BUTTON = 7,
  PARAGRAPH = 8,
  ORG_ID = 9,
  TEXT_SECRET = 10,
  TEXTAREA = 11,
  /** ENUM_WITH_DEPENDENTS is an enum field that has dependents that should be updated when the field changes. */
  ENUM_WITH_DEPENDENTS = 12
}

export enum Capability {
  CAPABILITY_UNSPECIFIED = 0,
  CAPABILITY_BROADCAST_NOTE = 1,
  CAPABILITY_SEND_NOTE = 2,
  CAPABILITY_SEND_CONTENT = 3
}

export interface IntegrationField {
  name: string;
  type: FieldType;
  key: string;
  capabilityMapping: Capability[];
  /**
   * Dependents are the keys of other IntegrationFields which should be updated when this
   * field changes. Example: If an MS Teams team and channel are selected and the selected
   * team changes, a new channel must be selected since channels are scoped by team.
   */
  dependents: string[];
}

export interface UserDetailLink {
  linkUrl: string;
  linkText: string;
}

export interface Note {
  id: string;
  created: protobuf.timestamp | null;
  creator: string;
  individualId: string;
  userId: string;
  sessionId: string;
  pageId: string;
  absTime: protobuf.timestamp | null;
  text: string;
  link: string;
  sentIntegrations: { [key: string]: string };
}

export interface SendModal {
  /** fieldname->field */
  fields: { [key: string]: SendModalField };
  /** fieldname->value */
  values: { [key: string]: string };
  /** Indicates if the config fields can be changed */
  disallowConfigChange: boolean;
}

export interface SendModalField {
  /** Human-friendly name or description */
  desc: string;
  type: FieldType;
  /** Indicates whether the field is a special config field */
  isConfig: boolean;
  /** Optional sort index; used for sorting config fields, for which alphabetical may not be the optimal sorting algorithm */
  sortIndex: number;
  enum: { [key: string]: string };
  required: boolean;
  children: { [key: string]: SendModalField };
}

export interface NoteDescriptionItem {
  name: string;
  value: string;
}
